import React from 'react'
import { Themed } from '../../components'
import styles from './Radio.module.css'

const Radio = props => (
  <Themed styles={styles} theme={props.theme}>
    {(cx, css) => (
      <div className={cx({
        radio: true,
        isActive: props.selected,
        ...props.classNames,
      })}>
        <label>
          <div>
            <div className={css.input}>
              <input
                type="radio"
                name={props.name}
                value={props.value}
                onChange={props.onChange} />
            </div>
          </div>
          <div>
            <div className={css.label}>{props.label}</div>
          </div>
        </label>
      </div>
    )}
  </Themed>
)

export default Radio
